if (!customElements.get('bundle-variants')) {
  customElements.define(
    'bundle-variants',
    class BundleProductVariants extends HTMLElement {
      constructor() {
        super();

        this.selectInputs = this.querySelectorAll('.main-product__select');
        this.selectionValues = [];
        this.productId = this.dataset.productId;

        document.addEventListener('DOMContentLoaded', () => {
          const selectInputs = document.querySelectorAll('.main-product__select');
          selectInputs.forEach((selectInput, index) => {
            this.selectionValues.push(selectInput.value);

            selectInput.addEventListener('input', () => {
              this.selectionValues[index] = selectInput.value;
            });
          });

          // Fetch variant data via API
          this.fetchAllVariants();
        });
      }

      // Fetch all variants using GraphQL Storefront API (supports up to 2,048 variants)
      fetchAllVariants = async () => {
        try {
          // 1. Build selected options object
          const selectedOptions = {};
          this.selectionValues.forEach((value, index) => {
            selectedOptions[`option${index + 1}`] = value;
          });

          // 2. Fetch variants using GraphQL Storefront API with pagination
          const productId = this.productId;
          let allVariants = [];
          let hasNextPage = true;
          let cursor = null;

          while (hasNextPage) {
            const query = `
                query getProductVariants($id: ID!, $first: Int!, $after: String) {
                  product(id: $id) {
                    variants(first: $first, after: $after) {
                      pageInfo {
                        hasNextPage
                        endCursor
                      }
                      edges {
                        node {
                          id
                          title
                          sku
                          price {
                            amount
                          }
                          compareAtPrice {
                            amount
                          }
                          availableForSale
                          quantityAvailable
                          selectedOptions {
                            name
                            value
                          }
                        }
                      }
                    }
                  }
                }
              `;

            const variables = {
              id: `gid://shopify/Product/${productId}`,
              first: 250, // Fetch 250 variants per request
              after: cursor,
            };

            const response = await fetch('/api/2025-10/graphql.json', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                'X-Shopify-Storefront-Access-Token': window.purdey.store_front_api,
              },
              body: JSON.stringify({ query, variables }),
            });

            if (!response.ok) {
              throw new Error(`GraphQL error! status: ${response.status}`);
            }

            const result = await response.json();
            const variantsData = result.data?.product?.variants;

            if (!variantsData) {
              throw new Error('No variant data returned from GraphQL');
            }

            // Add variants to our collection
            allVariants = allVariants.concat(
              variantsData.edges.map((edge) => ({
                id: edge.node.id.split('/').pop(), // Extract numeric ID
                name: edge.node.title,
                sku: edge.node.sku,
                price: parseFloat(edge.node.price.amount) * 100, // Convert to cents
                compare_at_price: edge.node.compareAtPrice
                  ? parseFloat(edge.node.compareAtPrice.amount) * 100
                  : null,
                available: edge.node.availableForSale,
                inventory_quantity: edge.node.quantityAvailable,
                option1: edge.node.selectedOptions[0]?.value,
                option2: edge.node.selectedOptions[1]?.value,
                option3: edge.node.selectedOptions[2]?.value,
                options: [
                  edge.node.selectedOptions[0]?.value,
                  edge.node.selectedOptions[1]?.value,
                  edge.node.selectedOptions[2]?.value,
                ],
              }))
            );

            // Check if there are more pages
            hasNextPage = variantsData.pageInfo.hasNextPage;
            cursor = variantsData.pageInfo.endCursor;
          }

          // 3. Filter client-side to find matching variant
          const matchedVariant = allVariants.find((variant) => {
            return Object.keys(selectedOptions).every((optionKey) => {
              return variant[optionKey] === selectedOptions[optionKey];
            });
          });

          // 4. Display the matched variant data
          if (matchedVariant) {
            document.dispatchEvent(
              new CustomEvent('bundleVariantsFetched', {
                detail: allVariants,
              })
            );
          } else {
            console.warn('No matching variant found for:', selectedOptions);
            console.log('Total variants searched:', allVariants.length);
          }
        } catch (error) {
          console.error('Error fetching variants via GraphQL:', error);
        }
      };
    }
  );
}
